import { Permission } from './permission';

export class AppRoleListing {
  id: number;
  name: string;
  description: string;
  AppRoleAccounts: AppRoleAccount[];
}

export class AppRoleWithPermissions extends AppRoleListing {
  permissions: Permission[];
}

export class AppRoleSummary extends AppRoleListing {
  constructor() {
    super();
    this.id = 0;
    this.name = '';
    this.description = '';
    this.AppRoleAccounts = [];
  }
}

export class AppRoleAccount {
  AppRoleId: number;
  AccountId: number;
}

export interface IAppRoleListOnly {
  id: number;
  name: string;
  description: string;
}

export class TokenClaims {
  appRoleId: string;
  //DBName: string;
  //DBUserName: string;
  //ServerName: string;
  aud: string;
  exp: string;
  iat: string;
  id: string;
  iss: string;
  jti: string;
  nbf: string;
  sub: string;
}
